export enum EnvironmentType {
  Dev = 'development',
  Stage = 'stage',
  Prod = 'production',
  Local = 'local',
}
